import { useMemo } from 'react';
import { filterItems } from "../functions/filterItems.js";
import { standardSearchFilter } from "../functions/standardSearchFilter.js";
export function useFilteredItems(items, searchString, filterFn = standardSearchFilter) {
  return useMemo(() => {
    if (typeof searchString === 'undefined' || searchString === '') {
      return items;
    }
    const {
      folderResults,
      optionResults
    } = filterItems(items, searchString, filterFn);
    return [...folderResults, ...optionResults];
  }, [items, searchString, filterFn]);
}